// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._26j1I6SU3N9WI7xK4QFa3p {\r\n    max-width: 640px;\r\n    min-height: 568px;\r\n    display: grid;\r\n    \r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n}\r\n\r\n._32rfR8colL6ZQpAw13Aqdi {\r\n    display: none;\r\n    text-align: center;\r\n    background-position: center center;\r\n    background-size: cover;\r\n}\r\n\r\n\r\n@media screen and (min-width: 768px) {\r\n    ._26j1I6SU3N9WI7xK4QFa3p {\r\n        width: 640px;\r\n        grid-template-columns: 1fr 1fr;\r\n    }\r\n\r\n    ._32rfR8colL6ZQpAw13Aqdi {\r\n        display: block;\r\n    }\r\n}\r\n\r\n.pVl_q4oREGGIMqvPtxbXu {\r\n    padding: 24px 24px 24px 24px;\r\n}\r\n\r\n.B4wcuF9wYGoq84Cq17bBM {\r\n    position: relative;\r\n}\r\n\r\n._2SyhnntKhANbONGZXDlVsV {\r\n    margin-bottom: 24px;\r\n    margin-right: 24px;\r\n}", ""]);
// Exports
exports.locals = {
	"container": "_26j1I6SU3N9WI7xK4QFa3p",
	"cover": "_32rfR8colL6ZQpAw13Aqdi",
	"content": "pVl_q4oREGGIMqvPtxbXu",
	"content-inner": "B4wcuF9wYGoq84Cq17bBM",
	"header": "_2SyhnntKhANbONGZXDlVsV"
};
module.exports = exports;
